module.exports = __webpack_public_path__ + "img/IMG_9432_L_Foamcore.f508d097.jpg";